import type { ProductBatchUpdateDto } from "src/app/features/Product/types/ProductBatchUpdateDto";
import type { ProductBatchUpdateEntity } from "src/app/features/Product/types/ProductBatchUpdateEntity";

export const ProductBatchUpdateEntityToBatchUpdateDto = ({ ...rest }: Readonly<ProductBatchUpdateEntity>): ProductBatchUpdateDto => {
    return { ...rest };
};
